module.exports = __webpack_public_path__ + "img/webtoon-ex2.33f7e67.png";